import { render, staticRenderFns } from "./CustomBrandingLogo.vue?vue&type=template&id=a1407a00&"
import script from "./CustomBrandingLogo.vue?vue&type=script&lang=js&"
export * from "./CustomBrandingLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QFile,QIcon});
